export const constraints = {
    cepNavegacao: {
        presence: {
            message: "^ Cep é obrigatório."
        },
        length: {
            minimum: 8,
            maximum: 8,
            message: "^ Cep é muito curto"
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cep-navigation/constraints.js